export default {
  format: 'components.views.placeholders.generator-placeholder.format',
  unitNumber: 'components.views.placeholders.generator-placeholder.unit-number',
  dieline: 'components.views.placeholders.generator-placeholder.dieline',
  placeholderUrl:
    'components.views.placeholders.generator-placeholder.placeholder-url',
  dimensions: 'components.views.placeholders.generator-placeholder.dimensions'
}
